import { render } from "./CanvasDrawingsGrid.vue?vue&type=template&id=a9947d1c&scoped=true"
import script from "./CanvasDrawingsGrid.vue?vue&type=script&lang=js"
export * from "./CanvasDrawingsGrid.vue?vue&type=script&lang=js"

import "./CanvasDrawingsGrid.vue?vue&type=style&index=0&id=a9947d1c&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9947d1c"]])

export default __exports__